{
  "nl": {
    "signature": {
      "actions": {
        "clearSignature": "Wis handtekening",
        "edit": "Bewerken",
        "request": "Vraag handtekening",
        "save": "Opslaan",
        "sign": "Teken"
      },
      "labels": {
        "add": "Toevoegen",
        "add_customer_signatures": "Je moet handtekeninglocaties van klanten toevoegen voordat u opslaat.",
        "add_team_member_signatures": "Je moet handtekeninglocaties voor teamleden toevoegen voordat u opslaat.",
        "all_customers_signed": "Alle klanten die moesten tekenen hebben al getekend. De documenten moeten nog worden ondertekend door vertegenwoordigers van {client_name} en het voorstel wordt goedgekeurd zodra dit gebeurd is. Er is geen verdere actie van uw kant vereist.",
        "browserNotSupported": "We hebben vastgesteld dat uw mobiele browser mogelijk geen elektronische handtekeningen ondersteunt. Als je problemen ondervindt, gelieve een andere browser of apparaat te proberen, of een ondertekend document te uploaden.",
        "customer_signatories": "Aantal handtekeningen klant",
        "customers_left_to_sign": "1 klant moet ondertekenen | {customers_left_to_sign} klanten moeten ondertekenen",
        "customers_required_to_sign": "Nog 1 klant moet de documenten ondertekenen. | {customers_left_to_sign} klanten moeten de documenten ondertekenen.",
        "customers_signed_names": "Klanten hebben al getekend: {names}",
        "documents_to_sign": "Te tekenen documenten",
        "draw_signature": "Teken jouw handtekening hieronder",
        "troubleSigningUpload": "Problemen met ondertekenen? Upload in plaats daarvan een ondertekend document",
        "employee_signatories": "{client_name} ondertekenaars",
        "employees_signed_names": "Teamleden hebben al getekend: {names}",
        "empty_signature_warning": "Gelieve jouw handtekening eerst te tekenenen.",
        "marked": "Plaats handtekening aangeduid",
        "next": "Volgende",
        "no_signature_indicators_warning": "Gelieve aan te duiden waar het document moet getekend worden, door op die pagina('s) te klikken.",
        "ok": "Ok",
        "original": "Origineel",
        "page": "pagina",
        "place_signature_subtitle": "Klik op de plaatsen waar de klant elektronisch moet tekenen.",
        "place_signature_title": "Duid handtekeningzone aan",
        "read_and_sign": "Ik heb gelezen en wens te ondertekenen",
        "read_documents": "Gelieve de volgende documenten te lezen alvorens te tekenen",
        "remove": "Verwijderen",
        "requesting_signage": "Vraag handtekening van",
        "sign": "Ondertekenen",
        "signatories_for_all_documents": "Aantal ondertekenaars geldt voor alle documenten. Als u dit wijzigt, worden alle handtekeningen verwijderd en moet je ze opnieuw toevoegen.",
        "signatureNotPossible": "Electronisch ondertekenen is niet beschikbaar voor dit bestandsformaat",
        "signatureNotPossibleSize": "Electronisch ondertekenen is niet beschikbaar voor bestanden groter dan 40 MB",
        "signatures_pending_from_client": "Handtekeningen in behandeling van team {client_name}",
        "signed": "Ondertekend",
        "signed_progress": "Ondertekend: {already_signed_count} van {all_required_to_sign_count}",
        "specifyWhereToSign": "Duid handtekeningzone aan",
        "team_member": "Teamlid",
        "team_member_signature_warning": "Je kan bewegwijzering van teamleden aanvragen nadat u bewegwijzering van klanten heeft aangevraagd.",
        "thank_you_for_signing": "Bedankt!",
        "toBeSigned": "Te ondertekenen"
      }
    }
  }
}
